import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const  Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    margin-bottom: 25px;
    @media(max-width: 640px) {
        flex-direction: column;
        justify-content: start;
    }
`;


export const  Item = styled.div`
    width: calc(50% - 12px);
    border-radius: 4px;
    border: 1px solid ${COLORS.lightGrey};
    @media(max-width: 640px) {
        width: 100%;
        margin-bottom: 25px;
    }
`;

export const Form = styled.div`
    display: flex;
    flex-direction: column;
    padding: 35px 36px;
    background-color: ${COLORS.white};
    border-radius: 4px;
    overflow: hidden;
    width: 100%;
    position: relative;
`;

export const FormTitle = styled.h2`
    color: ${COLORS.black};
    font-size: 24px;
    margin: 0 0 26px 0;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    font-weight: 300;
    line-height: 1.33;
    span {
        display: inline-block;
    }
`;
